__turbopack_context__.v({
  "description": "form-field-module__lAkI_q__description",
  "error": "form-field-module__lAkI_q__error",
  "errorMessage": "form-field-module__lAkI_q__errorMessage",
  "inputStandalone": "form-field-module__lAkI_q__inputStandalone",
  "label": "form-field-module__lAkI_q__label",
  "required": "form-field-module__lAkI_q__required",
  "root": "form-field-module__lAkI_q__root",
  "textareaStandalone": "form-field-module__lAkI_q__textareaStandalone",
});
